import { NgModule } from "@angular/core";
import { MatDialogModule } from "@angular/material/dialog";
import { MatButtonModule } from "@angular/material/button";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";

import { ThemeModule } from "../../@theme/theme.module";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { HomeComponent } from "./vta.home.component";
import { NgxMaskDirective, provideEnvironmentNgxMask } from "ngx-mask";
import { TextBoxModule } from "@syncfusion/ej2-angular-inputs";
import { ButtonModule } from "@syncfusion/ej2-angular-buttons";
import {
  FilterService,
  GridModule,
  PageService,
  PagerModule,
  SortService,
} from "@syncfusion/ej2-angular-grids";

const maskConfigFunction: () => Partial<any> = () => {
  return {
    validation: false,
  };
};

@NgModule({
  imports: [
    FormsModule,
    ThemeModule,
    MatDialogModule,
    MatButtonModule,
    MatProgressSpinnerModule,
    NgxMaskDirective,
    TextBoxModule,
    ReactiveFormsModule,
    ButtonModule,
    GridModule,
    PagerModule,
  ],
  exports: [HomeComponent],
  declarations: [HomeComponent],
  providers: [
    provideEnvironmentNgxMask(maskConfigFunction),
    PageService,
    FilterService,
    SortService,
  ],
})
export class HomeModule {}
